import styled from 'styled-components';

export const HomePageWrapper = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: rgb(239, 243, 248);
  position: relative;
`;
export const PageBackground = styled.div`
  width: 111rem;
  height: 95rem;
  background-color: rgb(34, 118, 227);
  position: absolute;
  top: -53rem;
  left: -69rem;
  transform: translate(50%);
  z-index: 2;
  border-radius: 50%;
`;
export const PageBackgroundLight = styled.div`
  width: 117rem;
  height: 100rem;
  background-color: rgb(109, 164, 234);
  position: absolute;
  top: -58rem;
  left: -76rem;
  transform: translate(50%);
  border-radius: 50%;
`;
export const PageContentWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 120rem;
  margin: 0px auto;
`;
export const PageHeader = styled.h1(
  props => `
    font-size: 2.2rem;
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    z-index: 9;
    color: rgb(255, 255, 255);
    margin: 2rem 0px;
  `,
);

export const SearchBlock = styled.section`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 7rem;
`;

export const OfferBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  z-index: 3;
`;

export const Overlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 5;
  background: rgba(0, 0, 0, 0.5);
`;
